import { useEffect, useMemo, useRef, useState } from 'react'
// import { errorHandle } from '../../api/api'
import { getAllQueuesByName } from '../../classes/Queue'
import { useUserContext } from '../../context/userContext'
import { Table } from '../shared'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { useToast } from '@chakra-ui/react'

const TableUserQueue = ({ targetName, filterQueueID }) => {
    const toast = useToast()
    const { userData } = useUserContext()
    const [data, setData] = useState(null)
    const loadData = useRef()
    loadData.current = async () => {
        // search all
        await getAllQueuesByName(targetName, userData.token)
            .then(res => {
                if(filterQueueID){
                    setData(res.filter(i=>i.id!==filterQueueID))
                }else{
                    setData(res)
                }
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    const columns = useMemo(() => {
        let cols = [
            {
                Header: 'ลำดับคิว',
                accessor: 'order'
            },
            {
                Header: 'อาคาร',
                accessor: 'residence_name'
            },
            {
                Header: 'วันที่ยื่น',
                accessor: 'submit_date',
            }, 
            {
                Header: 'ยื่นเวลา',
                accessor: 'submit_time',
            }
        ]

        return cols
    }, [])

    useEffect(() => {
        loadData.current()
    }, [targetName])

    return (
        <>
            {data && <Table columns={columns} data={data} options={{showPagination:false, emptyRowSize : "10px"}} mb={2}/>}
        </>
    )
}

export default TableUserQueue